const downloadFile = (url) => {
  const fileName = url.substring(url.lastIndexOf('/') + 1);
  const req = new XMLHttpRequest();
  req.open('GET', url, true);
  req.responseType = 'blob';
  req.onload = () => {
    const blob = new Blob([req.response], { type: 'application/octetstream' });
    const isIE = false || !!document.documentMode;
    if (isIE) {
      window.navigator.msSaveBlob(blob, fileName);
    } else {
      const url2 = window.URL || window.webkitURL;
      const link = url2.createObjectURL(blob);
      const a = document.createElement('a');
      a.setAttribute('download', fileName);
      a.setAttribute('href', link);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };
  req.send();
};

export default downloadFile;
